import { GridFilterInputBoolean } from '../components/panel/filterPanel/GridFilterInputBoolean';
export const getGridBooleanOperators = () => [{
  value: 'is',
  getApplyFilterFn: filterItem => {
    if (!filterItem.value) {
      return null;
    }

    const valueAsBoolean = filterItem.value === 'true';
    return ({
      value
    }) => {
      return Boolean(value) === valueAsBoolean;
    };
  },
  InputComponent: GridFilterInputBoolean
}];


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/colDef/gridBooleanOperators.js
// module id = 1068
// module chunks = 25